import {
    blueGrey,
    deepPurple,
    green,
    pink,
    red,
    amber,
} from '@material-ui/core/colors';
import { APPOINTMENT_TYPE_AI_CALL } from 'src/constants/appointment';
import { SUBSTATUS_RESCHEDULED_APPOINTMENT } from 'src/constants/mongo/status';
import { IAppointmentCalendar } from 'src/interfaces/appointment';
import moment from 'moment';

/**
 * Will return the color of the appointment based on the type, status and date
 *
 * @param {string} type
 * @return {*}
 */
export const getAppointmentColor = (
    appointment: IAppointmentCalendar
): string => {
    if (appointment.type === APPOINTMENT_TYPE_AI_CALL) {
        return pink['A100'];
    }

    if (appointment.substatus === SUBSTATUS_RESCHEDULED_APPOINTMENT) {
        return deepPurple[400];
    }
    if (
        moment(appointment.startDate).format('YYYY-MM-DD') >
        moment().format('YYYY-MM-DD')
    ) {
        return green[300];
    }
    if (
        moment(appointment.startDate).format('YYYY-MM-DD') <
        moment().format('YYYY-MM-DD')
    ) {
        return red[300];
    }

    return amber[200];
};
